import {defineMessages, useIntl} from 'react-intl';

import {view} from '@sail/ui';

import {dotComColors, dotComTransitions} from '../../theme/dotCom';
import {HoverArrow} from '../DotComButton/DotComButton';

const messages = defineMessages({
  label: {
    id: 'conversations_ui.widget.header.createStripeAccountLink.label',
    description: 'Label used for a link to open a Stripe account.',
    defaultMessage: 'Create account',
  },
});

export function CreateStripeAccountLink() {
  const intl = useIntl();

  return (
    <view.a
      href="https://dashboard.stripe.com/register/start_now"
      target="_blank"
      className="DotComButton"
      css={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'xsmall',
        font: 'label.large.emphasized',
        fontWeight: 600,
        color: dotComColors.brandButton,
        transition: dotComTransitions.buttonTransition,
        transitionProperty: 'color',
        ':hover': {
          color: dotComColors.brand500,
        },
      }}
    >
      {intl.formatMessage(messages.label)}
      <HoverArrow />
    </view.a>
  );
}
